import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContentfulService } from '../contentful.service';
import { SharedDataService } from "../shared-data.service";
import { VimeoService } from "../vimeo.service";
import { Entry, Asset, EntryCollection } from 'contentful';

declare function LoadPlyr(): any;
declare function ApplyCarrousell(): any;

@Component({
  selector: 'app-module-list',
  templateUrl: './module-list.component.html',
  styleUrls: ['./module-list.component.css']
})
export class ModuleListComponent implements OnInit {

  public selectedModuleId: string;
  public topics: Entry<any>[] = [];
  public selectedModule: Entry<any>;
  public TopicsVisible: boolean[] = [];
  public resources: Entry<any>[] = [];

  constructor(private router: Router, private contentfulService: ContentfulService, private sharedData: SharedDataService, private vimeo: VimeoService) { }

  ngOnInit() {
    this.selectedModuleId = sessionStorage.getItem("moduleId");
    //this.sharedData.currentModule.subscribe(message => this.selectedModuleId = message);
    this.contentfulService.getModule(this.selectedModuleId).then(x => this.selectedModule = x);
    this.contentfulService.getTopicsByModule(this.selectedModuleId).then(x => this.topics = x);
  }

  ShowResources(TopicId,i) {
    if (this.TopicsVisible[i] == true) {
      this.TopicsVisible[i] = false;
    }
    else {
      this.TopicsVisible[i] = true;
      this.contentfulService.getResourcesByTopic(TopicId).then(x => this.resources = x);
      LoadPlyr();
      ApplyCarrousell();
    }
  }
}

